/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StabilityPrediction } from './StabilityPrediction';
import {
    StabilityPredictionFromJSON,
    StabilityPredictionFromJSONTyped,
    StabilityPredictionToJSON,
    StabilityPredictionToJSONTyped,
} from './StabilityPrediction';
import type { Predictsnp } from './Predictsnp';
import {
    PredictsnpFromJSON,
    PredictsnpFromJSONTyped,
    PredictsnpToJSON,
    PredictsnpToJSONTyped,
} from './Predictsnp';
import type { ResultInhibitor } from './ResultInhibitor';
import {
    ResultInhibitorFromJSON,
    ResultInhibitorFromJSONTyped,
    ResultInhibitorToJSON,
    ResultInhibitorToJSONTyped,
} from './ResultInhibitor';
import type { Conservation } from './Conservation';
import {
    ConservationFromJSON,
    ConservationFromJSONTyped,
    ConservationToJSON,
    ConservationToJSONTyped,
} from './Conservation';
import type { Pka } from './Pka';
import {
    PkaFromJSON,
    PkaFromJSONTyped,
    PkaToJSON,
    PkaToJSONTyped,
} from './Pka';
import type { Mutation } from './Mutation';
import {
    MutationFromJSON,
    MutationFromJSONTyped,
    MutationToJSON,
    MutationToJSONTyped,
} from './Mutation';
import type { PredictorOutput } from './PredictorOutput';
import {
    PredictorOutputFromJSON,
    PredictorOutputFromJSONTyped,
    PredictorOutputToJSON,
    PredictorOutputToJSONTyped,
} from './PredictorOutput';
import type { Hope } from './Hope';
import {
    HopeFromJSON,
    HopeFromJSONTyped,
    HopeToJSON,
    HopeToJSONTyped,
} from './Hope';

/**
 * 
 * @export
 * @interface Results
 */
export interface Results {
    /**
     * 
     * @type {string}
     * @memberof Results
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Results
     */
    uniprotAccession: string;
    /**
     * 
     * @type {string}
     * @memberof Results
     */
    proteinCode: string;
    /**
     * 
     * @type {ResultsProteinTypeEnum}
     * @memberof Results
     */
    proteinType: ResultsProteinTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Results
     */
    structure: boolean;
    /**
     * 
     * @type {string}
     * @memberof Results
     */
    sequence: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Results
     */
    essentialResidues: Array<number>;
    /**
     * 
     * @type {Mutation}
     * @memberof Results
     */
    mutation: Mutation;
    /**
     * 
     * @type {StabilityPrediction}
     * @memberof Results
     */
    foldx?: StabilityPrediction;
    /**
     * 
     * @type {StabilityPrediction}
     * @memberof Results
     */
    rosetta?: StabilityPrediction;
    /**
     * 
     * @type {Predictsnp}
     * @memberof Results
     */
    predictsnp?: Predictsnp;
    /**
     * 
     * @type {Hope}
     * @memberof Results
     */
    hope?: Hope;
    /**
     * 
     * @type {Conservation}
     * @memberof Results
     */
    conservation: Conservation;
    /**
     * 
     * @type {Array<Pka>}
     * @memberof Results
     */
    pka?: Array<Pka>;
    /**
     * 
     * @type {Array<ResultInhibitor>}
     * @memberof Results
     */
    inhibitors?: Array<ResultInhibitor>;
    /**
     * 
     * @type {PredictorOutput}
     * @memberof Results
     */
    prediction?: PredictorOutput;
}


/**
 * @export
 */
export const ResultsProteinTypeEnum = {
    ProtoOncogene: 'PROTO_ONCOGENE',
    TumorSuppressor: 'TUMOR_SUPPRESSOR'
} as const;
export type ResultsProteinTypeEnum = typeof ResultsProteinTypeEnum[keyof typeof ResultsProteinTypeEnum];


/**
 * Check if a given object implements the Results interface.
 */
export function instanceOfResults(value: object): value is Results {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('uniprotAccession' in value) || value['uniprotAccession'] === undefined) return false;
    if (!('proteinCode' in value) || value['proteinCode'] === undefined) return false;
    if (!('proteinType' in value) || value['proteinType'] === undefined) return false;
    if (!('structure' in value) || value['structure'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    if (!('essentialResidues' in value) || value['essentialResidues'] === undefined) return false;
    if (!('mutation' in value) || value['mutation'] === undefined) return false;
    if (!('conservation' in value) || value['conservation'] === undefined) return false;
    return true;
}

export function ResultsFromJSON(json: any): Results {
    return ResultsFromJSONTyped(json, false);
}

export function ResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Results {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'uniprotAccession': json['uniprotAccession'],
        'proteinCode': json['proteinCode'],
        'proteinType': json['proteinType'],
        'structure': json['structure'],
        'sequence': json['sequence'],
        'essentialResidues': json['essentialResidues'],
        'mutation': MutationFromJSON(json['mutation']),
        'foldx': json['foldx'] == null ? undefined : StabilityPredictionFromJSON(json['foldx']),
        'rosetta': json['rosetta'] == null ? undefined : StabilityPredictionFromJSON(json['rosetta']),
        'predictsnp': json['predictsnp'] == null ? undefined : PredictsnpFromJSON(json['predictsnp']),
        'hope': json['hope'] == null ? undefined : HopeFromJSON(json['hope']),
        'conservation': ConservationFromJSON(json['conservation']),
        'pka': json['pka'] == null ? undefined : ((json['pka'] as Array<any>).map(PkaFromJSON)),
        'inhibitors': json['inhibitors'] == null ? undefined : ((json['inhibitors'] as Array<any>).map(ResultInhibitorFromJSON)),
        'prediction': json['prediction'] == null ? undefined : PredictorOutputFromJSON(json['prediction']),
    };
}

export function ResultsToJSON(json: any): Results {
    return ResultsToJSONTyped(json, false);
}

export function ResultsToJSONTyped(value?: Results | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uniprotAccession': value['uniprotAccession'],
        'proteinCode': value['proteinCode'],
        'proteinType': value['proteinType'],
        'structure': value['structure'],
        'sequence': value['sequence'],
        'essentialResidues': value['essentialResidues'],
        'mutation': MutationToJSON(value['mutation']),
        'foldx': StabilityPredictionToJSON(value['foldx']),
        'rosetta': StabilityPredictionToJSON(value['rosetta']),
        'predictsnp': PredictsnpToJSON(value['predictsnp']),
        'hope': HopeToJSON(value['hope']),
        'conservation': ConservationToJSON(value['conservation']),
        'pka': value['pka'] == null ? undefined : ((value['pka'] as Array<any>).map(PkaToJSON)),
        'inhibitors': value['inhibitors'] == null ? undefined : ((value['inhibitors'] as Array<any>).map(ResultInhibitorToJSON)),
        'prediction': PredictorOutputToJSON(value['prediction']),
    };
}

